import { Alias, Field, RowPropertyName } from './types'

const { cvId, createdAt, createdBy, updatedAt, updatedBy, submission } = RowPropertyName

export const rowPropertyAliases = new Map<RowPropertyName, Alias>([
  [
    cvId,
    {
      display: 'Claravine ID',
      db: 'cv_id',
    },
  ],
  [
    createdAt,
    {
      display: 'Created Date',
      db: 'properties.createdAt',
    },
  ],
  [
    createdBy,
    {
      display: 'Created By',
      db: 'properties.createdById',
    },
  ],
  [
    updatedAt,
    {
      display: 'Last Updated Date',
      db: 'properties.updatedAt',
    },
  ],
  [
    updatedBy,
    {
      display: 'Last Updated By',
      db: 'properties.updatedById',
    },
  ],
  [
    submission,
    {
      display: 'Submission Name',
      db: 'properties.submissionId',
    },
  ],
])

export const rowPropertyFields: Field[] = [
  {
    description: null,
    fieldId: 0,
    governanceType: 'property',
    name: rowPropertyAliases.get(cvId)!.display,
    precedence: null,
    required: false,
    rowPropertyName: cvId,
    visible: false,
  },
  {
    description: null,
    fieldId: 0,
    governanceType: 'property',
    name: rowPropertyAliases.get(submission)!.display,
    precedence: null,
    required: false,
    rowPropertyName: submission,
    visible: false,
  },
  {
    description: null,
    fieldId: 0,
    governanceType: 'property',
    name: rowPropertyAliases.get(createdAt)!.display,
    precedence: null,
    required: false,
    rowPropertyName: createdAt,
    visible: false,
  },
  {
    description: null,
    fieldId: 0,
    governanceType: 'property',
    name: rowPropertyAliases.get(createdBy)!.display,
    precedence: null,
    required: false,
    rowPropertyName: createdBy,
    visible: false,
  },
  {
    description: null,
    fieldId: 0,
    governanceType: 'property',
    name: rowPropertyAliases.get(updatedAt)!.display,
    precedence: null,
    required: false,
    rowPropertyName: updatedAt,
    visible: false,
  },
  {
    description: null,
    fieldId: 0,
    governanceType: 'property',
    name: rowPropertyAliases.get(updatedBy)!.display,
    precedence: null,
    required: false,
    rowPropertyName: updatedBy,
    visible: false,
  },
]
